import styled from 'styled-components';

export const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.28);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    z-index: ${({ $zIndex }) => ($zIndex != null ? $zIndex : 1040)};
    opacity: ${({ $open }) => ($open ? 1 : 0)};
    visibility: ${({ $open }) => ($open ? 'visible' : 'hidden')};
    transition:
        opacity 0.25s ease,
        visibility 0.25s ease;
    pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};
`;

export const Panel = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: ${({ $width }) => $width};
    ${({ $minWidth }) => ($minWidth ? `min-width: ${$minWidth};` : '')}
    max-width: ${({ $maxWidth }) => ($maxWidth ? `min(${$maxWidth}, 100vw)` : '100vw')};
    background: ${({ theme }) =>
        theme.colors.background.default === '#141414' ? theme.colors.background.secondary : '#ffffff'};
    box-shadow: -4px 0 24px rgba(0, 0, 0, 0.15);
    z-index: ${({ $zIndex }) => ($zIndex != null ? $zIndex : 1050)};
    display: flex;
    flex-direction: column;
    transform: translateX(${({ $open }) => ($open ? '0' : '100%')});
    transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1);
    overflow: hidden;
`;

export const PanelHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid ${({ theme }) => (theme.colors.background.default === '#141414' ? '#2C2C2C' : '#f0f0f0')};
    flex-shrink: 0;
`;

export const PanelTitle = styled.h2`
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: ${({ theme }) => (theme.colors.background.default === '#141414' ? '#fff' : '#000')};
    font-family: var(--font-family-geist);
`;

export const CloseButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    border-radius: 8px;
    color: ${({ theme }) =>
        theme.colors.background.default === '#141414' ? 'rgba(255,255,255,0.65)' : 'rgba(0,0,0,0.45)'};
    cursor: pointer;
    transition:
        color 0.2s,
        background 0.2s;

    &:hover {
        color: ${({ theme }) => (theme.colors.background.default === '#141414' ? '#fff' : '#000')};
        background: ${({ theme }) => (theme.colors.background.default === '#141414' ? '#2C2C2C' : '#f5f5f5')};
    }

    .anticon {
        font-size: 18px;
    }
`;

export const PanelBody = styled.div`
    flex: 1;
    min-width: 0;
    overflow-x: hidden;
    overflow-y: ${({ $overflowY }) => $overflowY || 'auto'};
    padding: ${({ $padding }) => ($padding != null ? $padding : '24px 32px 24px 24px')};
`;
